import { ErrorHandler, Injector, LOCALE_ID, NgModule } from '@angular/core';
import { BrowserModule, bootstrapApplication } from '@angular/platform-browser';
import { RouteReuseStrategy } from '@angular/router';

import { IonicModule, IonicRouteStrategy } from '@ionic/angular';

import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { environment } from 'src/environments/environment';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { registerLocaleData } from '@angular/common';

import localePt from '@angular/common/locales/pt';
import localeExtraPT from '@angular/common/locales/extra/pt';
import localeEn from '@angular/common/locales/en';
import localeEs from '@angular/common/locales/es';
import { Interceptor } from './alcance/providers/interceptor.interceptor';
import { FaIconLibrary, FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faCalendarCheck, faFileSignature, faLightbulb, fas } from '@fortawesome/free-solid-svg-icons';
import { far } from '@fortawesome/free-regular-svg-icons';
import { provideEnvironmentNgxMask } from 'ngx-mask';
// import { BackgroundMode } from '@awesome-cordova-plugins/background-mode/ngx';
import { PendenciaService } from './services/pendencia.service';
import PendenciaDBService from './database/pendencia-db.service';
import { AtividadeDBService } from './database/atividade-db.service';
import { AtividadeService } from './services/atividade.service';
import { EquipamentoDBService } from './database/equipamento-db.service';
import { EquipamentoService } from './services/equipamento.service';
import { AtaDBService } from './database/ata-db.service';
import { AtaService } from './services/ata.service';
import { PlantaoDBService } from './database/plantao-db.service';
import { PlantaoService } from './services/plantao.service';
import { UsuarioDBService } from './database/usuario-db.service';
import { UsuarioService } from './services/usuario.service';
import { FullCalendarModule } from '@fullcalendar/angular';
import { EditorModule, TINYMCE_SCRIPT_SRC } from '@tinymce/tinymce-angular';
import * as Sentry from "@sentry/angular";
import { PlantaService } from './services/planta.service';
import { EstoqueService } from './services/estoque.service';
import { EstoqueDBService } from './database/estoque-db.service';
import { PontoEncontroService } from './services/ponto-encontro.service';
import { PontoEncontroDBService } from './database/ponto-encontro-db.service';
import { IonicStorageModule } from '@ionic/storage-angular';
import { Drivers } from '@ionic/storage';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TRANSLATE_HTTP_LOADER_CONFIG, TranslateHttpLoader } from '@ngx-translate/http-loader';
import { DEFAULT_LOCALE, getPersistedLocale } from './i18n/i18n.config';
import { setAppInjector } from './app-injector';

registerLocaleData(localePt, 'pt-BR', localeExtraPT);
registerLocaleData(localeEn, 'en');
registerLocaleData(localeEs, 'es');

export const httpInterceptorProviders = [
    { provide: HTTP_INTERCEPTORS, useClass: Interceptor, multi: true },
];

@NgModule({
    declarations: [AppComponent],
    imports: [
        BrowserModule,
        IonicModule.forRoot({
            innerHTMLTemplatesEnabled: true
        }),
        IonicStorageModule.forRoot({
            name: '__ebrigada',
            driverOrder: [Drivers.IndexedDB]
        }),
        HttpClientModule,
        AppRoutingModule,
        FullCalendarModule,
        EditorModule,
        FontAwesomeModule,
        TranslateModule.forRoot({
            fallbackLang: DEFAULT_LOCALE,
            lang: DEFAULT_LOCALE,
            loader: {
                provide: TranslateLoader,
                useClass: TranslateHttpLoader
            }
        })
    ],
    providers: [
        { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
        { provide: LOCALE_ID, useFactory: getPersistedLocale },
        {
            provide: TRANSLATE_HTTP_LOADER_CONFIG,
            useValue: { prefix: '/assets/i18n/', suffix: '.json' }
        },
        { provide: TINYMCE_SCRIPT_SRC, useValue: 'tinymce/tinymce.min.js' },
        // { provide: ErrorHandler, useValue: Sentry.createErrorHandler({showDialog: false, logErrors: environment.production}), },
        httpInterceptorProviders,
        provideEnvironmentNgxMask(),
        // BackgroundMode,
        {provide: 'PendenciaService', useExisting: PendenciaService},
        {provide: 'PendenciaDBService', useExisting: PendenciaDBService},
        {provide: 'AtividadeService', useExisting: AtividadeService},
        {provide: 'AtividadeDBService', useExisting: AtividadeDBService},
        {provide: 'EquipamentoService', useExisting: EquipamentoService},
        {provide: 'EquipamentoDBService', useExisting: EquipamentoDBService},
        {provide: 'PlantaService', useExisting: PlantaService},
        {provide: 'AtaService', useExisting: AtaService},
        {provide: 'AtaDBService', useExisting: AtaDBService},
        {provide: 'PlantaoService', useExisting: PlantaoService},
        {provide: 'PlantaoDBService', useExisting: PlantaoDBService},
        {provide: 'EstoqueService', useExisting: EstoqueService},
        {provide: 'EstoqueDBService', useExisting: EstoqueDBService},
        {provide: 'UsuarioService', useExisting: UsuarioService},
        {provide: 'UsuarioDBService', useExisting: UsuarioDBService},
        {provide: 'PontoEncontroService', useExisting: PontoEncontroService},
        {provide: 'PontoEncontroDBService', useExisting: PontoEncontroDBService},
    ].concat(environment.production ? [{provide: ErrorHandler, useValue: Sentry.createErrorHandler({showDialog: false})}] as any : []),
    bootstrap: [AppComponent],
})
export class AppModule {
    constructor(library: FaIconLibrary, private injector: Injector) {
        // Add an icon to the library for convenient access in other components
        // library.addIcons(faFileSignature, faLightbulb, faCalendarCheck);
        library.addIconPacks(fas, far);

        setAppInjector(this.injector);
    }
}

// bootstrapApplication(AppComponent, {
//     providers: [
//         provideEnvironmentNgxMask(),
//     ],
// }).catch((err) => console.error(err));
